import { XCircleIcon } from "@heroicons/react/16/solid";
import { METHOD_TYPE_TRANSLATIONS } from "@services/TranslateCsvHeaders";
import { USER_TYPE } from "@constants/Enums";

type FailedUsersTableProps = {
  externalContact?: boolean;
  failedUsers: [];
  handleDeleteUser: (index: number) => void;
};

export const FailedUsersTable: React.FC<FailedUsersTableProps> = ({
  externalContact = true,
  failedUsers,
  handleDeleteUser,
}) => {
  return (
    <div className="ml-2 mr-2 sm:ml-4 sm:mr-4">
      <div className="ml-2 mr-2 sm:ml-4 sm:mr-4">
        <table className="table-auto w-full border-collapse">
          <thead>
            <tr className="bg-gray-100 text-gray-600">
              <th className="border-b border-gray-300 p-3 text-left w-1/4">
                {externalContact ? "行目" : "ID"}
              </th>
              <th className="border-b border-gray-300 p-3 text-left w-1/4">
                氏名
              </th>
              <th className="border-b border-gray-300 p-3 text-left w-1/3">
                エラー
              </th>
              <th className="border-b border-gray-300 p-3 text-left w-1/5">
                操作
              </th>
              <th className="border-b border-gray-300 p-3 text-center w-[100px] whitespace-nowrap">
                削除
              </th>
            </tr>
          </thead>
          <tbody>
            {failedUsers?.map((user, index) => (
              <tr
                key={index}
                className="hover:bg-gray-50 transition-colors ease-in-out"
              >
                <td className="border-t border-gray-300 p-3">
                  {user.user?.user_type === USER_TYPE.KEYCLOAK_USER
                    ? user.user?.login_id
                    : user.user?.user_type == USER_TYPE.INTERNAL
                    ? "なし"
                    : user.user?.row || "なし"}
                </td>
                <td className="border-t border-gray-300 p-3">
                  {user.user?.last_name} {user.user?.first_name}
                </td>
                <td className="border-t border-gray-300 p-3">{user.error}</td>
                <td className="border-t border-gray-300 p-3">
                  {METHOD_TYPE_TRANSLATIONS[user.method] || "未知の操作"}
                </td>
                <td className="border-t border-gray-300 p-3 text-center">
                  <button
                    className="text-red-600 hover:text-red-800 transition-colors ease-in-out"
                    onClick={() => handleDeleteUser(index)}
                    title="削除"
                  >
                    <XCircleIcon className="w-5 h-5 mx-auto" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
